module.exports = __webpack_public_path__ + "static/img/bubble.885e14c.png";


//////////////////
// WEBPACK FOOTER
// ./static/bubble.png
// module id = XuK0
// module chunks = 0